import { styled } from '@mui/system';
import { IconButton, Typography } from '@mui/material';

interface InfoDivProps {
  hidden: boolean;
}

const InfoDiv = styled('div', {
  shouldForwardProp: (prop) => prop !== 'hidden',
})<InfoDivProps>(({ hidden, theme }) => ({
  display: 'flex',
  alignItems: 'center',
  height: hidden ? '0px' : '40px',
  padding: hidden ? '0px 5px 0px 22px' : '5px 5px 5px 22px',
  marginTop: hidden ? '0px' : '12px',
  backgroundColor: '#E6F3FA',
  transition: 'all 0.3s ease-in-out',
  [theme.breakpoints.down(470)]: {
    height: hidden ? '0px' : '60px',
  },
  '& *': {
    opacity: hidden ? 0 : 1,
    transition: 'opacity 0.3s ease-in-out',
  },
}));

const InfoIconButton = styled(IconButton)({
  padding: '0',
  marginRight: '17px',
  color: '#414046',
});

const InfoTypography = styled(Typography)({
  fontFamily: 'Poppins',
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: '15.6px',
  letterSpacing: '0.15px',
  color: '#414046',
  span: {
    fontWeight: 500,
  },
});

export { InfoDiv, InfoIconButton, InfoTypography };
